import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';

import { useEffect } from 'react';
import { useAppDispatch } from '../../../../App/redux/store';
import Button from '../../../../components/Assets/Button';
import TextInput from '../../../../components/Forms/TextInput';
import useQuery from '../../../../utils/useQuery';
import { resetOrCreatePasswordThunk } from '../../services/authThunks';
import { passwordResetSchema } from './constants';

interface IPasswordResetFormProps {
  path: string;
}

function PasswordResetForm({ path }: IPasswordResetFormProps) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const query = useQuery();

  useEffect(() => {
    if (!query.get('token')) {
      navigate('/connexion', { replace: true });
    }
  }, [query, navigate]);

  const formik = useFormik({
    initialValues: {
      username: query.get('username'),
      password: '',
      token: query.get('token'),
    },
    validationSchema: passwordResetSchema,
    onSubmit: (values) => {
      if (path === '/premier-mot-de-passe') {
        dispatch(resetOrCreatePasswordThunk({ ...values, navigate, isNew: true }));
      }
      if (path === '/recuperation-mot-de-passe') {
        dispatch(resetOrCreatePasswordThunk({ ...values, navigate }));
      }
    },
  });

  const { values, touched, errors } = formik;

  return (
    <form className="password-form" noValidate>
      <TextInput
        name="username"
        label="Email"
        type="email"
        value={values.username}
        handleChange={formik.handleChange}
        error={touched.username && Boolean(errors.username)}
        helperText={errors.username}
      />
      <TextInput
        name="password"
        label="Mot de passe"
        type="password"
        value={values.password}
        handleChange={formik.handleChange}
        error={touched.password && Boolean(errors.password)}
        helperText={errors.password}
      />
      <Button
        btnType="submit"
        btnContent="ENVOYER"
        primary
        handleClick={formik.handleSubmit}
      />
    </form>
  );
}

export default PasswordResetForm;
